import { Check as Check_kojaro } from './Check.kojaro';
import { Check as Check_phosphor } from './Check.phosphor';
import { Check as Check_zoomg } from './Check.zoomg';
import { Check as Check_zoomit } from './Check.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Check_kojaro;

    case 'zoomg':
      return Check_zoomg;

    case 'phosphor':
      return Check_phosphor;

    default:
      return Check_zoomit;
  }
};

export const Check = IconRenderer();
